// extracted by mini-css-extract-plugin
export default {"bg":"Modal_bg__LXCi8","content":"Modal_content__9kvi2","modal":"Modal_modal__wXgF5","modal__content":"Modal_modal__content__XTcFN","modal__close":"Modal_modal__close__31AZ0"};